module.exports = __webpack_public_path__ + "img/card.47a1cf70.svg";